import { memo, useCallback } from 'react';
import { useTranslation } from '@bonanza-social/i18n';
import { useSelector } from '@bonanza-social/toolkit/state';
import { useNavigation } from '@bonanza-social/navigation';
import { selectStatus } from '../../state/status/status.slice';
import { openStatusProgressInfo } from '../../utils/status';
import { StatusPromotionProps } from './StatusPromotion.types';
import StatusPromotionAnimation from './StatusPromotionAnimation/StatusPromotionAnimation';
import StatusChange from '../StatusChange/StatusChange';

function StatusPromotion({ onButtonPress, ...rest }: StatusPromotionProps) {
  const [t] = useTranslation('status');
  const navigation = useNavigation();
  const status = useSelector(selectStatus);
  const context = { context: status?.playerStatus };

  const renderAnimation = useCallback(
    (onAnimationEnd: () => void) =>
      status?.playerStatus && (
        <StatusPromotionAnimation
          playerStatus={status.playerStatus}
          onAnimationEnd={onAnimationEnd}
        />
      ),
    [status?.playerStatus],
  );

  const handleButtonPress = useCallback(() => {
    if (!status) {
      return;
    }

    onButtonPress();

    openStatusProgressInfo(status, navigation);
  }, [status, onButtonPress, navigation]);

  if (!status) {
    return;
  }

  return (
    <StatusChange
      heading={t('statusPromotionHeading', context)}
      subheading={t('statusPromotionSubheading', context)}
      title={t('statusPromotionTitle', context)}
      description={t('statusPromotionDescription', {
        count: status.keepStatusNumberOfBoxes,
        allGemsCount: status.promotionNumberOfBoxes,
        nextStatus: status.nextPlayerStatus,
        ...context,
      })}
      buttonText={t('statusPromotionButton', context)}
      renderAnimation={renderAnimation}
      onButtonPress={handleButtonPress}
      {...rest}
    />
  );
}

export default memo(StatusPromotion);
